import {MidmileMonitoring} from '../../components/midmile';

const MidmilePage = () => {
  const token = localStorage.getItem('token') 
  return <MidmileMonitoring token={token}/>;
};

export default MidmilePage;
